import React, { Component } from 'react';
import { connect } from 'react-redux';
import './banner.scss';
import aboutBanner from '../../../../statics/a-banner.jpg';
class Banner extends Component {

  constructor(props) {
    super(props);
  }

  render () {

    const { title, desc, bannerSrc, en } = this.props;

    return (
      <div className="a-banner">
        <img className="a-banner__pic" alt="" src={bannerSrc ? bannerSrc : aboutBanner}></img>
        <div className="a-banner__cta">
          <h1 className="a-banner__title">{title}</h1>
          {
            desc ? (
              <p className="a-banner__l-desc">{desc}</p>
            ) : null
          }
          {
            en ? (
              <p className="a-banner__l-desc">{en}</p>
            ) : null
          }
        </div>
      </div>
    )
  }
}

export default connect(null, null)(Banner);
